// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2G7fc","inputDescription":"styles_inputDescription__34Ofv"};